import { useState, forwardRef, useCallback } from 'react';
import Webcam from 'react-webcam';
import {
  Box, Button
} from '@mui/material';
import FlipCameraAndroidOutlinedIcon from '@mui/icons-material/FlipCameraAndroidOutlined';
import { useStyles } from './style';

export const Camera = forwardRef((props, ref) => {
  const classes = useStyles();

  const FACING_MODE_USER = 'user';
  const FACING_MODE_ENVIRONMENT = 'environment';
  const videoConstraints = {
    facingMode: FACING_MODE_USER
  };

  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);

  const changeCameraHandler = useCallback(() => {
    setFacingMode(
      (prevState) => (prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER)
    );
  }, []);

  return (
    <>
      <Box className={classes.changeCameraWrapper}>
        <Button className={classes.changeCameraBtn} onClick={changeCameraHandler}>
          <FlipCameraAndroidOutlinedIcon className={classes.changeCameraIcon} />
        </Button>
      </Box>
      <Webcam
        audio={false}
        screenshotFormat="image/jpeg"
        ref={ref}
        videoConstraints={{
          ...videoConstraints,
          facingMode
        }}
        width="500"
        height="500"
        className={classes.root}
      />
    </>
  );
});
